export const partners = [
    {
        name: 'شرکت مخابرات ایران',
        desc: 'شریک فناوری و تجاری در توسعه و پیاده‌سازی محصول مرکز تماس ابری مخابرات (متاما)',
        img: '/svg/new/partners/tci.svg',
    },
    {
        name: 'ایرانسل',
        desc: 'شریک فناوری ایرانسل در توسعه و پیاده‌سازی محصول مرکز تماس ابری ایرانسل',
        img: '/svg/new/partners/irancel.svg',
    },
    {
        name: 'آسیاتک',
        desc: 'همکاری در توسعه و عرضه\nخدمات تلفن ابری آسیاتک',
        img: '/svg/new/partners/asiatech.svg',
    },
    {
        name: 'دفتر پیشخوان دولت',
        desc: 'عرضه خدمات نواتل از طریق\nدفاتر پیشخوان دولت',
        img: '/svg/new/partners/pishkhan.svg',
    },
];